import colorMod from 'color';

export default ({ color, fontSize, typography }) => ({
  applyBtn: {
    backgroundColor: `${color.primaryButtonBackground} !important`,
    borderColor: `${color.primaryButtonBackground} !important`,
    color: `${color.primaryButtonText} !important`,
    fontSize: fontSize.buttonText,
    fontFamily: typography.buttonText,
    height: 40,
    '&:hover': {
      backgroundColor: `${color.primaryButtonHover} !important`,
      borderColor: `${color.primaryButtonHover} !important`,
    },
  },
  filter: {
    backgroundColor: color.white,
    position: 'absolute',
    marginTop: 10,
    zIndex: 100,
    boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 4px 0px, rgba(0, 0, 0, 0.2) 0px 4px 8px 0px',
    width: 500,
    fontSize: fontSize.small,
  },
  filterRankContainer: {
    marginLeft: 20,
    marginRight: 20,
  },
  buttonBar: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: 20,
    marginRight: 30,
  },
  textInput: {
    width: 80,
    height: 40,
    display: 'inline-block',
    '& input': {
      borderBottom: 0,
      height: 39,
      width: '100%',
    },
    '&:hover div': {
      borderColor: '#c8d1e0',
    },
  },
  invalidTextInput: {
    '& input': {
      borderColor: color.borderColorError,
    },
    '&:focus div': {
      boxShadow: `0 0 0 1px #ffffff, 0 0 0 2px ${color.borderColorError}`,
    },
    '& input:focus + div': {
      boxShadow: `0 0 0 1px #ffffff, 0 0 0 2px ${color.borderColorError}`,
    },
    '& div': {
      borderColor: color.borderColorError,
    },
  },
  filterLabel: {
    fontSize: fontSize.small,
  },
  searchBar: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  label: {
    marginBottom: 5,
  },
  cancelBtn: {
    background: color.primaryButtonText,
    border: '1px solid',
    borderColor: color.primaryButtonBackground,
    borderRadius: 3,
    color: color.primaryButtonBackground,
    height: '40px!important',
    fontFamily: typography.buttonText,
    fontSize: fontSize.buttonText,
    width: 75,
    outline: 'none',
    display: 'inline',
    textDecoration: 'none',
    lineHeight: '26px',
    marginLeft: 10,
    '&:focus': {
      outline: 'none',
      boxShadow: 'none',
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
    },
    '&:hover': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
    },
    '&:active': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
    },
  },
  linkBtn: {
    borderColor: '#fff',
    border: 'none',
    height: '40px!important',
    background: 'none',
    outline: 'none',
    display: 'inline',
    color: color.primaryButtonBackground,
    fontSize: fontSize.small,
    textDecoration: 'none',
    '&:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
  },
  linkBar: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: 20,
  },
  filterTypeContainer: {
    borderBottom: `1px solid ${color.borderColor}`,
    paddingLeft: 20,
    paddingTop: 20,
  },
  filterTypeBtn: {
    border: 'none',
    borderBottom: '2px solid rgba(0, 0, 0, 0)',
    background: '#fff',
    height: 26,
    width: 50,
    color: color.link,
    padding: 0,
    fontFamily: typography.buttonText,
    fontSize: fontSize.buttonText,
    '&:hover': {
      color: color.linkHover,
    },
    '&:focus': {
      boxShadow: 'none',
    },
    '& span': {
      padding: 0,
    },
  },
  filterTypeBtnSelected: {
    color: color.bodyText,
    borderBottom: `2px solid ${color.bodyText}`,
    padding: 0,
    borderRadius: 0,
    '&:hover': {
      color: color.bodyText,
    },
  },
  filterTitle: {
    marginLeft: 20,
    marginTop: 20,
    color: color.pageTitle,
    fontFamily: typography.pageTitle,
    fontSize: fontSize.title,
  },
  slots: {
    fontSize: 10,
  },
  disableBtn: {
    pointerEvents: 'none',
    borderColor: `${colorMod(color.bodyText).alpha(0.05).string()} !important`,
    backgroundColor: `${colorMod(color.bodyText).alpha(0.05).string()} !important`,
    color: color.bodyText,
  },
});